import React from "react";
import GUIButton from "../GUIButton";
import closeIcon from "images/mainland/selfie-close.png";
import "./index.scss";

const CloseButton = props => {
  const {onClick} = props;

  return (
    <div className="selfie-close-btn" onClick={onClick}>
      <img src={closeIcon} alt="close" />
    </div>
  );
};

export default CloseButton;
